import { render, staticRenderFns } from "./NewsletterSubscribe.vue?vue&type=template&id=643d010e&scoped=true&"
import script from "./NewsletterSubscribe.vue?vue&type=script&lang=js&"
export * from "./NewsletterSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterSubscribe.vue?vue&type=style&index=0&id=643d010e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d010e",
  null
  
)

export default component.exports